import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import styled, { css } from 'styled-components';
import { chartsActions } from '../../redux/root-action';
import RetirementIncomeChart from './RetirementIncomeChart';
import SavingsBalanceChart from './SavingsBalanceChart';
import { GlobalErrorComponent } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import { charts } from '../../utils/constants';
import { keyDown } from '../../utils/helpers';

const StyledListTabs = styled.div`
  padding: 0;
  margin: 0;
  list-style: none;
`;

const StyledTabTitleItem = styled.div<{
  isActiveTab: boolean;
}>`
  display: inline-block;
  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  cursor: pointer;
  font-family: "Nimbus Sans Regular";
  color: ${tokens.ColorGrey700};
  font-size: 16px;
  line-height: 22px;
  padding-bottom: 16px;
  width: 50%;
  text-align: center;
   &:hover {
     opacity: 1;
   }
   border-bottom: 4px solid transparent;
   ${(props: any) =>
     props.isActiveTab &&
     css`
       cursor: pointer;
       font-family: Nimbus Sans Bold;
       color: ${tokens.ColorGrey800};
       opacity: 1;
       border-bottom: 4px solid ${tokens.ColorLightBlue};
     `}
  }
  @media (max-width: 1024px){
    padding-bottom: 12px;
  }
`;

const StyledTabsContainer = styled.div`
  border-bottom: 1px solid ${tokens.ColorGrey400};
  margin: 40px;
  @media (max-width: 1024px) {
    margin: 32px 48px;
  }
  @media (max-width: 768px) {
    margin: 0 0 24px;
  }
`;

const GlobalErrorContainer = styled.div`
  margin-top: 72px;
`;

const HideOnMobile = styled.span`
  display: none;
  @media (min-width: 1024px) {
    display: inline
  }
`;

const chartsList = [
  {
    id: charts.RETIREMENT_INCOME,
    title: 'Retirement Income',
  },
  {
    id: charts.SAVINGS_BALANCE,
    title: 'Savings Balance',
  },
];
const chartItem = '';
class Charts extends Component<any, any> {
  onClick = (chart: any) => () => {
    const { selectChart } = this.props;
    selectChart(chart);
  };

  componentDidMount() {
    const { fetchSimulationCurrentWant } = this.props;
    fetchSimulationCurrentWant();
  }

  render() {
    const mq = window.matchMedia('(max-width: 1024px)');
    const mqMobile = window.matchMedia('(max-width: 768px)');
    const { selectedChart, error } = this.props;
    const showError = Number(error.status) > 300 && Number(error.status) < 600;

    return (
      <React.Fragment>
        {(mqMobile.matches || (!showError && !mqMobile.matches)) && (
          <StyledTabsContainer>
            <StyledListTabs>
              {chartsList.map((chartItem, index) => (
                <StyledTabTitleItem
                  key={index}
                  onClick={this.onClick(chartItem)}
                  tabIndex={0}
                  onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, this.onClick(chartItem))}
                  id={chartItem.id}
                  isActiveTab={selectedChart.id === chartItem.id}
                >
                  <div>{chartItem.title} <HideOnMobile> Over Time</HideOnMobile></div>
                </StyledTabTitleItem>
              ))}
            </StyledListTabs>
          </StyledTabsContainer>
        )}
        {showError ? (
          <GlobalErrorContainer>
            <GlobalErrorComponent
              message={`We’re having trouble updating your chart. Please try again.`}
              refreshText={`Refresh Chart`}
              hideOverlay={true}
            />
          </GlobalErrorContainer>
        ) : (
          <>
            {selectedChart.id === charts.RETIREMENT_INCOME && <RetirementIncomeChart />}
            {selectedChart.id === charts.SAVINGS_BALANCE && <SavingsBalanceChart />}
          </>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ charts: { selectedChart, error } }: any) => {
  return {
    selectedChart,
    error,
  };
};

export default connect(mapStateToProps, {
  selectChart: chartsActions.selectChart,
  fetchSimulationCurrentWant: chartsActions.fetchSimulationCurrentWant,
})(Charts);
function e(
  e: any,
  chartItem: { id: string; title: string; mobileTitle: string },
): React.KeyboardEventHandler<HTMLAnchorElement> | undefined {
  throw new Error('Function not implemented.');
}
